import * as api from "services/api";
import { getErrors } from "helpers/error";
import { Callback } from "Types/Callback";
import IUser from "Types/User";
import { State } from "store/reducers";
import { AsYouType } from "libphonenumber-js";

export const GET_USER = "[USER EDIT] GET_USER";
export const GET_USER_SUCCESS = "[USER EDIT] GET_USER_SUCCESS";
export const GET_USER_FAILED = "[USER EDIT] GET_USER_FAILED";

export const EDIT_USER = "[USER EDIT] EDIT_USER";
export const EDIT_USER_SUCCESS = "[USER EDIT] EDIT_USER_SUCCESS";
export const EDIT_USER_FAILED = "[USER EDIT] EDIT_USER_FAILED";

export const SET_VALUE = "[USER EDIT] SET_VALUE";
export const CLEAR_VALUES = "[USER EDIT] CLEAR_VALUES";

export function setValue(payload: any) {
	return (dispatch: any) => {
		dispatch({ type: SET_VALUE, payload });
	};
}
export function clearValues() {
	return { type: CLEAR_VALUES };
}

export function getUser(id: string, callback?: Callback<IUser>) {
	return async (dispatch: any, getState: any) => {
		dispatch({ type: GET_USER });

		try {
			const { login } = getState() as State;

			const response = await api.sendGet("/User/" + id, {
				Authorization: `Bearer ${login.token}`
			});

			const result = await response.json();

			if (result.isValid) {
				dispatch({
					type: GET_USER_SUCCESS,
					payload: result.model
				});

				callback && callback(null, result.model);
			} else {
				const errors = getErrors(result.errors);

				dispatch({
					type: GET_USER_FAILED,
					payload: errors
				});
				callback && callback(errors);
			}
		} catch (error) {
			console.log(error);

			callback && callback(error);

			return dispatch({
				type: GET_USER_FAILED,
				payload: {
					error: "Connection error"
				}
			});
		}
	};
}

export function updateUser(id: string, callback?: Callback<IUser>) {
	return async (dispatch: any, getState: any) => {
		dispatch({ type: EDIT_USER });

		try {
			const state = getState() as State;

			const { login, userEdit } = state;

			const {
				item,
				email,
				name,
				lastname,
				role,
				phoneNumber,
				birthDate,
				cpf,
				address,
				status,
				userStatus,
				mei
			} = userEdit;

			const model = {
				...item,
				email,
				name,
				lastname,
				roles: ["user", role],
				phoneNumber: phoneNumber
					? new AsYouType().input(`+55${phoneNumber}`)
					: null,
				birthDate,
				cpf,
				address,
				status,
				userStatus,
				mei
			};

			const response = await api.sendPut("/User/" + id, model, {
				Authorization: `Bearer ${login.token}`
			});

			if (response.ok) {
				dispatch({
					type: EDIT_USER_SUCCESS
				});

				callback && callback();
			} else {
				const result = await response.json();

				const errors = getErrors(result.errors);

				dispatch({
					type: EDIT_USER_FAILED,
					payload: errors
				});
				callback && callback(errors);
			}
		} catch (error) {
			return dispatch({
				type: EDIT_USER_FAILED,
				payload: {
					error: "Connection error"
				}
			});
		}
	};
}
